<div class="container">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 mx-auto" style="margin-top: 10% !important;">

        <mat-card class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
            <mat-card-content>
                <div class="imgcontainer">
                    <img src="../../assets/logo_old.png" width="40" height="40" class="mr-3">
                    <h3>Painel de Autenticação</h3>
                </div>

                <form [formGroup]="formulario" (ngSubmit)="login()">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="margin-top: 20px !important;">
                            <mat-form-field mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Digite o seu CWID<span
                                        class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input type="text" matInput id="txtUsuario" name="txtUsuario" formControlName="Login" #txtUsuario
                                    maxlength="10">
                                <mat-hint align="end">{{ txtUsuario.value?.length || 0 }}/10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Login)}}</mat-error>
                            </mat-form-field>
                            <br>
                            <mat-form-field class="w-100 pt-3" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Digite a sua senha<span
                                        class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtSenha" formControlName="Senha" #txtSenha maxlength="10" id="txtSenha" name="txtSenha"
                                    [type]="hideSenha ? 'password' : 'text'">
                                <i matSuffix class="{{hideSenha ? 'fa fa-eye iconMenu' : 'fa fa-eye-slash iconMenu'}}"
                                    (click)="hideSenha = !hideSenha"></i>
                                <mat-hint align="end">{{ txtSenha.value?.length || 0 }}/10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Senha)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-md text-right">
                            <button mat-flat-button color="primary" matTooltip="Acessar Sistema" id="btnLogin"
                                (click)="login()" type="submit" class="btnSize">
                                <i class="fa fa-user"> Acessar</i>
                            </button>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>